module.exports = __webpack_public_path__ + "img/MTCIBANF.ea80138c.png";